import { render, staticRenderFns } from "./BrixFresh.vue?vue&type=template&id=37808b10"
import script from "./BrixFresh.vue?vue&type=script&lang=js"
export * from "./BrixFresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports